import BusinessIcon from '@mui/icons-material/Business';
import { Avatar, type AvatarProps } from '@mui/material';
import type { ReactNode } from 'react';

type Props = Omit<AvatarProps, 'src'> & { src?: string | null; fallback?: ReactNode };

/** Company mark: uploaded logo when present, otherwise the given fallback. */
export function OrgLogo({ src, fallback, children, sx, ...props }: Props) {
  const hasImage = !!src;
  return (
    <Avatar
      src={src ?? undefined}
      {...props}
      sx={[
        !hasImage && { bgcolor: 'primary.main' },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
        hasImage && { bgcolor: 'transparent', '& .MuiAvatar-img': { objectFit: 'contain' } },
      ]}
    >
      {!hasImage ? (children ?? fallback ?? <BusinessIcon />) : null}
    </Avatar>
  );
}
